export enum PageEnum {
    Dashboard = "dashboard",
    WelcomePage = "welcome-page",

    // Offers pages
    OfferSchedule = "offer-schedule",
    OfferManagement = "offer-management",
    OfferDashboard = "offer-dashboard",
    OfferDetail = "offer-detail",

    // Sponsored Ads pages
    SponsoredAdSchedule = "sponsored-ad-schedule",
    SponsoredAdManagement = "sponsored-ad-management",
    SponsoredAdDashboard = "sponsored-ad-dashboard",
    SponsoredAdDetail = "sponsored-ad-detail",
}
